import { browser } from '$app/environment'
import { payload } from '$lib/utils/payload/crud'
import { Result } from '$lib/utils/result'
import * as qs from 'qs-esm'
import type { PageLoad } from '../$types'
import { env } from '$env/dynamic/public'

const locales = ['cs', 'en']
const defaultLocale = 'cs'

function parseParams({ params }: { params: any }) {
      let { locale, slug } = params

      if (!locales.includes(locale)) {
            slug = locale
            locale = defaultLocale
      }

      return {
            locale,
            slug: slug ? slug : 'home',
      }
}

export const load: PageLoad = async (ctx: any) => {
      const { url, fetch, params, event, parent } = ctx

      const { locale, slug } = parseParams({ params })
      const { id } = params

      //console.log(id)
      //console.log('program', locale, slug, id)

      const q = {
            limit: 0,
            populate: {},
            depth: 2,
            locale: locale,
            where: undefined,
      } as {
            [keyof: string]: undefined | any
      }

      if (id) {
            q.where = {
                  id: {
                        equals: id,
                  },
            }
      }

      const { value: pages, Err } = await Result(() =>
            payload.find({
                  fetch: fetch,
                  collectionPath: '/program',
                  serverUrl: `${env.PUBLIC_PAYLOAD_URL}`,
                  query: qs.stringify(q),
                  origin: env.PUBLIC_SVELTE_URL,
            })
      )

      if (Err) {
            //console.error(Err.message, Err.stack)
      }

      if (Err || pages.docs.length == 0)
            return {
                  id: id,
                  page: [],
                  rawPageData: null,
            }

      return {
            id: id,
            page: pages.docs,
            rawPageData: pages,
      }
}
